export class Toast {
	id: number;
	type: ToastType;
	title: string;
	message?: string;
	detail?: any;
}

export enum ToastType {
	ERROR = 'error',
	SUCCESS = 'success',
}
